// modal trigger
if (!customElements.get("klayvio-modal-trigger")) {
  customElements.define(
    "klayvio-modal-trigger",
    class KlaviyoBackInStockModal extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId;
        this.ProductVariantId = this.dataset.productVariantId;
        this.productTitle = this.dataset.productTitle;

        this.modal = document.querySelector("klaviyo-modal");
        this.modalTitle = this.modal.querySelector(".product-title");
        this.overlayEl = document.querySelector(".klaviyo-modal-page-overlay");
      }

      connectedCallback() {
        this.addEventListener("click", this.openModal.bind(this));
      }

      openModal() {
        this.modalTitle.textContent = this.productTitle;
        this.modal.dataset.productId = this.productId;
        this.modal.dataset.productVariantId = this.ProductVariantId;
        this.modal.classList.add("show");
        this.overlayEl.classList.add("show");
      }
    }
  );
}

// modal
if (!customElements.get("klaviyo-modal")) {
  customElements.define(
    "klaviyo-modal",
    class KlaviyoBackInStockModal extends HTMLElement {
      constructor() {
        super();

        this.publicApiKey = this.dataset.klaviyoPublicApiKey || "";
        this.emailSubListId = this.dataset.klaviyoBisEmailSubscriptionsListId || "";

        this.closeButton = this.querySelector(".klaviyo-modal-close");
        this.closeButtonText = this.querySelector(".klaviyo-modal-close-text");
        this.overlayEl = document.querySelector(".klaviyo-modal-page-overlay");
        this.inputError = this.querySelector(".field-error");
        this.submitButton = document.querySelector(".klaviyo-subscribe-button");

        this.productID = this.dataset.productId || "";
        this.productVariantID = this.dataset.productVariantId || "";
        this.inputValue = this.querySelector(".klaviyo-subscriber-email");
        this.emailSubInput = this.querySelector(".email_subscription_consent");
        this.phoneInput = this.querySelector(".klaviyo-subscriber-phone-number");
        this.phoneNumberError = this.querySelector(".phone-number-error");
        this.modalSMSConsent = this.querySelector(".modal-sms-consent");

        this.buttonSpinner = this.querySelector(".klaviyo-subscribe-button .loading-overlay__spinner");
        this.buttonCopy = this.querySelector(".klaviyo-subscribe-button span");

        this.data = {};
      }

      connectedCallback() {
        this.closeButton.addEventListener("click", this.closeModal.bind(this));
        this.closeButtonText.addEventListener("click", this.closeModal.bind(this));
        this.overlayEl.addEventListener("click", this.closeModal.bind(this));
        this.submitButton.addEventListener("click", this.fetchSub.bind(this));
      }

      setData() {
        let channels = ["EMAIL"];
        let attributes = {
          email: this.inputValue.value,
        };

        if (this.phoneInput.value !== "" && this.phoneInput.value !== null) {
          channels.push("SMS");
          attributes.phone_number = this.phoneInput.value.replaceAll(" ", "");
        }

        const variant = `$shopify:::$default:::${this.productVariantID}`;
        this.data = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: attributes,
                },
              },
              channels: channels,
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: variant,
                },
              },
            },
          },
        };
      }

      fetchSub() {
        this.productID = this.dataset.productId || "";
        this.productVariantID = this.dataset.productVariantId || "";

        this.buttonCopy.classList.add("hidden");
        this.buttonSpinner.classList.remove("hidden");
        this.submitButton.setAttribute("disabled", "disabled");

        this.setData();

        const requestOptions = {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2024-10-15",
            "content-type": "application/vnd.api+json",
          },
          body: JSON.stringify(this.data),
        };

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.publicApiKey}`, requestOptions)
          .then((res) => {
            return res.text();
          })
          .then((response) => {
            const data = response ? JSON.parse(response) : {};
            this.inputError.classList.add("hidden");
            this.phoneNumberError.classList.add("hidden");
            if (data?.errors) {
              if (data?.errors[0]?.source?.pointer.includes("email")) {
                data?.errors.forEach((error) => {
                  this.inputError.textContent = error.detail;
                  this.inputError.classList.remove("hidden");
                });
              } else if (data?.errors[0]?.source?.pointer.includes("phone_number")) {
                data?.errors.forEach((error) => {
                  this.phoneNumberError.textContent = error.detail;
                  this.phoneNumberError.classList.remove("hidden");
                  this.modalSMSConsent.classList.add("extra-padding");
                });
              }
            } else {
              document.querySelector("klaviyo-modal .step-success").classList.remove("hidden");
              this.inputError.classList.add("hidden");
              this.phoneNumberError.classList.add("hidden");
              this.modalSMSConsent.classList.remove("extra-padding");

              // Sets user subscriptions - NOT NEEDED FOR WOOLROOM, ALSO PHONE FIELD IS HIDDEN ON FRONTEND
              // this.setUserSubscribtions(this.emailSubInput.checked, this.phoneInput.value !== '' ? true : false);
            }
          })
          .catch((error) => {
            document.querySelector("klaviyo-modal .step-error").classList.remove("hidden");
            this.submitButton.removeAttribute("disabled");
            this.buttonCopy.classList.remove("hidden");
            this.buttonSpinner.classList.add("hidden");
          })
          .finally(() => {
            this.submitButton.removeAttribute("disabled");
            this.buttonCopy.classList.remove("hidden");
            this.buttonSpinner.classList.add("hidden");
          });
      }

      closeModal() {
        this.classList.remove("show");
        this.querySelector("klaviyo-modal .step-form").classList.remove("hidden");
        this.querySelector("klaviyo-modal .step-error").classList.add("hidden");
        this.querySelector("klaviyo-modal .step-success").classList.add("hidden");
        this.querySelector(".klaviyo-subscriber-email").value = "";
        this.phoneNumberError.classList.add("hidden");
        this.phoneNumberError.textContent = "Please enter a valid phone number";
        this.phoneInput.value = "";
        this.inputError.classList.add("hidden");
        this.overlayEl.classList.remove("show");
      }

      setUserSubscribtions(email = false, phone = false) {
        if (!email && !phone) {
          this.inputValue.value = "";
          this.phoneInput.value = "";
          return;
        }

        let attributes = {};

        if (email && this.inputValue.value !== "") {
          attributes.email = this.inputValue.value;
        }

        if (phone && this.phoneInput.value !== "") {
          attributes.phone_number = this.phoneInput.value.replaceAll(" ", "");
        }

        const subscribeData = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: attributes,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: this.emailSubListId,
                },
              },
            },
          },
        };

        const subscribeOptions = {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2024-10-15",
            "content-type": "application/vnd.api+json",
          },
          body: JSON.stringify(subscribeData),
        };

        fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.publicApiKey}`, subscribeOptions)
          .then((res) => {
            this.inputValue.value = "";
            this.phoneInput.value = "";
          })
          .catch((err) => console.error(err));
      }
    }
  );
}
